
import * as request from 'request';
import { MimeType } from './mimeTypes';
import { bufferToString, downloadBuffer, stringToBuffer } from './util';

export function download({ contentType, body, filename, extension }: IResponseResult) {
  downloadBuffer(body!, filename || 'result', extension as MimeType);
}

export interface IResponseResult {
  errorMessage?: string;
  extension?: string;
  body?: Uint8Array;
  filename?: string;
  contentType: string;
}

const RESULT_LISTENERS: Array<(result?: IResponseResult) => void> = [];
export function onResult(listener: (result?: IResponseResult) => void) {
  RESULT_LISTENERS.push(listener);
}

function showResult(result?: IResponseResult) {
  RESULT_LISTENERS.forEach(listener => listener(result));
}
export function handleInvalidJson(errorMessage: any) {
  if (errorMessage) {
    const errbody = stringToBuffer(errorMessage.stack);
    return showResult({ contentType: '', extension: 'txt', errorMessage: `${errorMessage} `, filename: "Error", body: errbody });
  }
}
export function sendRequest(json: any, serverUrl?: string) {
  showResult();
  serverUrl = serverUrl || document.location.href;
  const expectedExtension = json.output.output_type ? json.output.output_type.replace('onepagepdf', 'pdf')
    : (json.template ? json.template.template_type : 'pdf');

  request.post(serverUrl, { json, encoding: null }, (error, response, body?: Uint8Array) => {
    if (error) {
      return showResult({ contentType: '', errorMessage: `Error while sending the request: ${error}` });
    }
    let contentType = response.headers['content-type'];
    console.log("response.headers:" + JSON.stringify(response.headers));
    console.log("output Type: " + JSON.stringify(json.output.output_type));
    contentType = contentType ? contentType.replace(/;.*$/, '') : '';
    console.log("setting content type to" + contentType);
    // Check transfer encoding (should be empty (plain text) or base64)
    const encoding = response.headers['content-transfer-encoding'];
    switch (encoding || 'plain') {
      case '':
      case 'plain':
        break;
      case 'base64':
        body = stringToBuffer(atob(bufferToString(body!)));
        break;
      default:
        return showResult({ contentType, errorMessage: `Unknown encoding: ${encoding}` });
    }
    let errorMessage!: string;
    // Read the other headers to get the file name/extension
    let extension = expectedExtension;
    const dispos = response.headers['content-disposition'];
    let filename = 'result';
    if (dispos) {
      const match = dispos.match(/\bfilename=([^.]+?)(?:\.(.*)|)$/);
      if (match) {
        filename = match[1];
        extension = match[2] || extension;
      } else {
        errorMessage = `Couldn't understand the following Content-Disposition: ${dispos}`;
        filename = 'Unknown';
        extension = "";
      }
    }
    // Check if something went wrong, and if so, handle it
    if (response.statusCode !== 200) {
      filename = 'error';
      const error_description = response.headers.error_description;
      if (error_description) {
        errorMessage = atob(error_description.toString());
        filename = 'error';
      } else {
        errorMessage = 'Something went wrong';
        errorMessage += ` (HTTP ${response.statusCode} ${response.statusMessage})`;
        body = response.body;
      }
    }
    // Use the above data to download/display the result
    if (contentType === "text/plain") {
      extension = "txt";
    }
    switch (extension) {
      case 'html':
      case 'md':
      case 'txt':
        showResult({ extension, errorMessage, filename, body, contentType });
        break;
      default:
        const result: IResponseResult = { extension: extension!, errorMessage, filename, body, contentType };
        showResult(result);
        download(result);
    }
  });
}

export interface ILog {
  id: number;
  urid: string;
  start_time: Date;
  end_time?: Date;
  json_size?: number;
  output_size?: number;
  remoteAddress: string;
  proxyAddress: string;
  output_type?: string;
  template_type?: string;
  logging_data: {
    template_filename?: string;
    output_filename?: string;
    user?: string;
    session?: string;
  };
  success: boolean;
  template_name?: string;
}

export interface ILoggingData {
  success: boolean;
  errorMessage?: string;
  error?: Error;
  logs?: ILog[];
}

export function fetchLogs(serverUrl?: string): Promise<ILog[]> {
  return new Promise<ILog[]>((resolve, reject) => {
    serverUrl = serverUrl || document.location.href;
    serverUrl = `${serverUrl.replace(/\/$/, '')}/logging/data?t=${Date.now()}`;
    request.get(serverUrl, { json: true }, (error: any, response: request.Response, body: ILoggingData) => {
      if (error) return reject(error);
      if (response.statusCode !== 200) return reject(new Error(`HTTP ${response.statusCode} ${response.statusMessage}`));
      if (!body) return reject(new Error(`No body returned`));
      if (!body.success) return reject(new Error(body.errorMessage || `The 'success' field is false`));
      if (!body.logs) return reject(new Error(`Missing field 'logs'`));
      resolve(body.logs);
    });
  });
}



// WEBPACK FOOTER //
// ./src/logic/requester.ts